import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Country to language mapping - English is default for all countries
// Users can manually select FR, DE, or ES from the language selector
const countryToLanguage: Record<string, string> = {
  // All countries default to English - no automatic language detection
};

// Custom language detector that maps countries to languages
const customLanguageDetector = {
  name: 'customNavigator',
  lookup() {
    // Check if user has manually selected a language
    const stored = localStorage.getItem('i18nextLng');
    if (stored) return stored;

    // Get browser language
    const browserLang = navigator.language || (navigator as any).userLanguage;
    if (browserLang) {
      const langCode = browserLang.split('-')[0].toLowerCase();
      const countryCode = browserLang.split('-')[1]?.toUpperCase();
      
      // First try country code mapping
      if (countryCode && countryToLanguage[countryCode]) {
        return countryToLanguage[countryCode];
      }
      
      // Then try language code directly
      if (['fr', 'de', 'en'].includes(langCode)) {
        return langCode;
      }
    }
    
    return 'en'; // Default to English
  },
  cacheUserLanguage(lng: string) {
    localStorage.setItem('i18nextLng', lng);
  },
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    lng: 'en', // Force English as default language
    supportedLngs: ['en', 'fr', 'de', 'es'],
    debug: false,
    
    detection: {
      order: ['localStorage', 'customNavigator', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    react: {
      useSuspense: true,
    },
  });

// Add custom detector
const languageDetector = new LanguageDetector();
languageDetector.addDetector(customLanguageDetector);

export default i18n;
